import {useStaticQuery, graphql} from 'gatsby';
import {formatDate} from '../utils/date-utils';

const RawDataDownloadLink = () => {
  const raw_data_path = (
    process.env.GATSBY_DOCUMENT_SERVER_PATH ?? 'https://primis.phmsa.dot.gov/enforcement-documents'
  ).concat('/PHMSA%20Pipeline%20Enforcement%20Raw%20Data.txt');

  const data = useStaticQuery(graphql`
    {
      postgres {
        scDataCurrency(dataset: "rawdata") {
          currencyDate
        }
      }
    }
  `);
  return (
    <a href={raw_data_path} id="raw-data-link" download>
      Enforcement Cases Initiated from 2002 (data as of {formatDate(data.postgres.scDataCurrency.currencyDate)})
    </a>
  );
};

export default RawDataDownloadLink;
